import React, { Component } from 'react';
import { Modal, Form, Select, Row, message, notification } from 'antd';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import styles from './CopyModal.less';
import Remark from './Remark';
import Content from './Content';
const FormItem = Form.Item;
const Option = Select.Option;

@inject('deviceConfigStore', 'deviceGroupStore')
@observer
class CopyModalFrom extends Component {
  @observable tabsData;
  @observable tablesData;
  @observable remarkData;
  componentDidMount() {
    this.props.deviceGroupStore.loadDeviceGroup();
  }

  @action.bound
  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.tabsData && this.tablesData && this.remarkData) {
          let content = {};
          [...this.tabsData].forEach((tab, index) => {
            let contentArr = Object.keys(JSON.parse(tab.content)).map(
              (keyItem, index) => {
                return {
                  lable: keyItem,
                  value: JSON.parse(tab.content)[keyItem]
                };
              }
            );
            let objData = contentArr.reduce(
              (prev, cur) => ({
                ...prev,
                [cur.lable]: cur.value
              }),
              {}
            );
            content[tab.title] = objData;
          });
          const formData = new FormData();
          formData.append('tag', values['tag_id']);
          formData.append('remark', this.remarkData);
          formData.append('content', JSON.stringify(content));
          this.props.deviceConfigStore
            .postConfiguration(formData)
            .then(json => {
              if (json.code === 200) {
                message.success('复制成功');
                // window.location.reload();
                this.props.deviceConfigStore.hideCopyModal(this.props.form);
                this.props.deviceConfigStore.loadConfigList(1);
              }
            });
        } else {
          notification['error']({
            message: '操作错误',
            description: '设备分组,配置说明,配置内容皆不能为空',
            duration: 0
          });
        }
      }
    });
  }

  @action.bound
  changeData(tabs, tables) {
    this.tabsData = tabs;
    this.tablesData = tables;
  }

  @action.bound
  changeRemark(val) {
    this.remarkData = val;
  }

  @action.bound
  hideModal() {}

  render() {
    const {
      copyModalStatus,
      copyModalData,
      hideCopyModal
    } = this.props.deviceConfigStore;
    const {
      getFieldDecorator,
      getFieldsError,
      getFieldError,
      isFieldTouched
    } = this.props.form;
    const { deviceGroupArr } = this.props.deviceGroupStore;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      }
    };
    return (
      <div className={styles.copyModalContainer}>
        {copyModalStatus && (
          <Modal
            visible={copyModalStatus}
            onOk={this.handleSubmit}
            onCancel={() => hideCopyModal(this.props.form)}
            width={'50%'}
          >
            <Form onSubmit={this.handleSubmit}>
              <FormItem label="设备分组:" {...formItemLayout}>
                {getFieldDecorator('tag_id', {
                  rules: [{ required: true, message: '请填写设备分组' }]
                })(
                  <Select placeholder="请填写设备分组">
                    {[...deviceGroupArr].map(item => (
                      <Option value={String(item.tag_id)} key={item.tag_id}>
                        {item.tag_name}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
              <Row className={styles.remarkContainer}>
                <Remark
                  labelCol={3}
                  wrapperCol={10}
                  changeRemark={this.changeRemark}
                />
              </Row>
              <Row>
                <Content
                  labelCol={3}
                  wrapperCol={21}
                  data={copyModalData}
                  changeContent={this.changeData}
                />
              </Row>
            </Form>
          </Modal>
        )}
      </div>
    );
  }
}
let CopyModal = Form.create()(CopyModalFrom);
export default CopyModal;



// WEBPACK FOOTER //
// ./src/components/DeviceConfig/CopyModal.js